import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ToggleFeedbackListButtonComponent } from '../toggle-feedback-list-button/toggle-feedback-list-button.component';

@Component({
  selector: 'h3-gen-ai-toolbar',
  imports: [ToggleFeedbackListButtonComponent],
  templateUrl: './gen-ai-toolbar.component.html',
  styleUrl: './gen-ai-toolbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenAiToolbarComponent {}
